export const VARIANTS = {
  default: {
    key: "default",
    label: "Accroche par défaut",
    lines: [
      { text: "Passez l'été au frais.", accent: false },
      { text: "Et l'hiver au chaud,", accent: false },
      { text: "sans surcoût.", accent: true },
    ],
    sub: (
      <>
        Climatisation réversible <strong className="text-ink">Daikin</strong> installée par nos
        propres techniciens RGE, en Gironde et dans tout le Sud-Ouest. Étude sur place gratuite,
        pose soignée et réglages inclus.
      </>
    ),
    image: "/clim-salon.webp",
    alt: "Unité murale Daikin dans un salon lumineux",
    widget: { value: "21 °C", caption: "quand il fait 38 °C dehors · dès 19 dB(A)" },
  },
  chaleur: {
    key: "chaleur",
    label: "Canicule / 21 °C",
    lines: [
      { text: "Canicule ?", accent: false },
      { text: "Retrouvez 21 °C chez vous", accent: true },
      { text: "en 15 jours.", accent: false },
    ],
    sub: (
      <>
        Nuits étouffantes, volets fermés toute la journée… Une climatisation{" "}
        <strong className="text-ink">Daikin</strong> posée sous 15 jours par nos propres
        techniciens RGE, et la maison redevient un refuge.
      </>
    ),
    image: "/clim-famille.webp",
    alt: "Famille au frais sous une climatisation Daikin",
    widget: { value: "21 °C", caption: "dans le salon quand il fait 38 °C dehors" },
  },
  silence: {
    key: "silence",
    label: "Silence / facture",
    lines: [
      { text: "Une clim qu'on n'entend pas.", accent: false },
      { text: "Une facture", accent: true },
      { text: "qu'on ne sent pas.", accent: true },
    ],
    sub: (
      <>
        Unités intérieures <strong className="text-ink">Daikin</strong> dès 19 dB(A) — moins qu'un
        chuchotement — et technologie Inverter qui ajuste la puissance en continu. Installée par
        nos techniciens RGE, sans sous-traitance.
      </>
    ),
    image: "/clim-salon.webp",
    alt: "Unité murale Daikin silencieuse dans un salon",
    widget: { value: "19 dB(A)", caption: "plus silencieux qu'un chuchotement" },
  },
  eco: {
    key: "eco",
    label: "3× moins cher",
    lines: [
      { text: "Chauffez et rafraîchissez", accent: false },
      { text: "pour 3 fois moins cher.", accent: true },
    ],
    sub: (
      <>
        Une climatisation réversible <strong className="text-ink">Daikin</strong> restitue 3 à 4 kWh
        de chaleur pour 1 kWh consommé : fraîcheur l'été, chauffage économique l'hiver. Étude gratuite
        par nos techniciens RGE.
      </>
    ),
    image: "/clim-exterieur.webp",
    alt: "Unité extérieure Daikin sur une maison en pierre en Gironde",
    widget: { value: "×3", caption: "plus efficace qu'un radiateur électrique" },
  },
};

export const VARIANT_KEYS = Object.keys(VARIANTS);

export const getVariant = (key) => VARIANTS[key] || VARIANTS.default;
